<template>
    <select :id="name" :name="name" style="width: 100%">
        <slot></slot>
    </select>
</template>

<script>

import 'select2/dist/css/select2.css';
import 'select2/dist/js/select2';

export default {
    name: "v-select-jq",
    props: ['options', 'value', 'name', 'class_css', 'parentId', 'placeholder'],
    mounted: function () {
        window.$ = window.jQuery = require('jquery');

        var vm = this;

        $(this.$el)
            .select2({
                // TODO: This is important, but doesn't seem to work well
                //allowClear: true,
                data: this.options,
                dropdownParent: $('#' + this.parentId),
                placeholder: this.placeholder,
            })
            .val(this.value)
            .trigger('change')
            .on('change', function () {
                vm.$emit('update:modelValue', this.value);
                vm.$emit('change');
            });
    },
    watch: {
        value: function (value) {
            $(this.$el)
                .val(value)
                .trigger('change');
        },
        options: function (options) {
            // update options
            $(this.$el).select2({data: options});
        }
    },
    methods: {
        removeAll() {
            $(this.$el).val(null).trigger('change');
        }
    },
    unmounted: function () {
        $(this.$el).off().select2('destroy');
    }
}
</script>
